import React, { useState, useEffect } from 'react';
import { Combobox } from 'evergreen-ui';
import PropTypes from 'prop-types';
import { api } from '../../services/api';

const SelectGithubTeamInput = ({ value, onSelect, disabled }) => {
  const [loading, setLoading] = useState(true);
  const [getTeams, setTeams] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await api.github.getTeams();
        setTeams(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <Combobox
      items={getTeams.map((team) => team.name)}
      selectedItem={value}
      onChange={(selected) => onSelect && onSelect(selected || null)}
      disabled={disabled}
      isLoading={loading}
      width="40%"
      openOnFocus
      data-testid="team"
    />
  );
};

SelectGithubTeamInput.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SelectGithubTeamInput.defaultProps = {
  value: null,
};

export default SelectGithubTeamInput;
